import { bus } from "../../main";
export const sidebarMixin = {
    data: function () {
        return {
            currentElementValue: {}
        }
    },
    computed:{
        fieldLabel() {
            return this.structure.required == "yes" ? this.structure.label + " *" : this.structure.label;
        } 
    },
    methods: {
        showField() {
            if (this.structure.hasOwnProperty("showWhen") && this.currentElementValue.hasOwnProperty('value')) {
                console.log(
                    "========================================================="
                );
                console.log("column Name:", this.index);
                console.log("fieldValue:", this.currentElementValue.value + " , " + " field name:" + this.currentElementValue.index);
                console.log("--------------------------------");
 

                const showWhen = Object.entries(this.structure.showWhen);
                for (const [elementName, value] of showWhen) {
                    console.log("elementName:", elementName + " id:" + value);

                    console.log(
                        "compare index: ",
                        elementName + " === " + this.currentElementValue.index
                    );

                    if (this.currentElementValue.index == elementName) {
                        if (value.includes("|")) {
                            //WE NEED TO CHECK IF IT HAS MULTIPLE VALUES
                            this.tempArray = value.split("|"); //IF IT DOES WE SPLIT IT
                            for (var i = 0, len = this.tempArray.length; i < len; i++) {
                                console.log(
                                    "compare multiple value: ",
                                    this.tempArray[i] + " === " + this.currentElementValue.value
                                );
                                if (this.tempArray[i] == this.currentElementValue.value) {
                                    console.log(
                                        "column Name MULTIPLE:",
                                        this.index + " IS SHOWN!!!!!!!!!!!!!!!!"
                                    );
                                    console.log("--------------END-----------------------------------");
                                    this.currentValueOfShowHideField = true;
                                    return true;

                                }
                            }
                        } else {
                            console.log(
                                "compare Single value: ",
                                value + " === " + this.currentElementValue.value
                            );
                            if (value == this.currentElementValue.value) {
                                console.log(
                                    "column Name Single:",
                                    this.index + " IS SHOWN!!!!!!!!!!!!!!!!"
                                );
                                console.log("--------------END-----------------------------------");
                                this.currentValueOfShowHideField = true;
                                return true;
                            }
                        }
                    } else {
                        console.log(
                            "not Related: return the current value",
                            this.index + " IS " + this.currentValueOfShowHideField
                        );
                         console.log("--------------END-----------------------------------");
                          return this.currentValueOfShowHideField;
                    }
                }
                console.log(this.index + " IS HIDDEN############");
                console.log("--------------END-----------------------------------");
                this.currentValueOfShowHideField = false;
                return false;
            } else {
                return true;
            }
        }
    },
    created() {
        bus.$on("showHideField", data => {
            this.currentElementValue = data;
            this.showField;
        });
    },
    beforeDestroy() {
        bus.$on("showHideField", data => {
            this.currentElementValue = data;
            this.showField;
        });
    }


};